/* Sticky header helpers: exposes header height and a scrolled state */
(function () {
  var wrap = document.getElementById('shopify-section-header');
  if (!wrap) return;
  var root = document.documentElement;
  function setH() { root.style.setProperty('--header-h', wrap.offsetHeight + 'px'); }
  var compact = false, scrolled = false;
  function onScroll() {
    var y = window.scrollY;
    // The scrolled header is shorter; when it shrinks the browser re-anchors the page by the same amount.
    // A wide dead-zone (on past 64px, off under 4px) stops that feedback loop flickering the header.
    if (!scrolled && y > 64) { scrolled = true; root.classList.add('is-scrolled'); }
    else if (scrolled && y < 4) { scrolled = false; root.classList.remove('is-scrolled'); }
    // fold the mobile logo row away once the shopper is browsing; hysteresis stops it flickering
    if (!compact && y > 140) { compact = true; root.classList.add('is-compact'); }
    else if (compact && y < 40) { compact = false; root.classList.remove('is-compact'); }
  }
  setH(); onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setH);
  if ('ResizeObserver' in window) new ResizeObserver(setH).observe(wrap);
})();

/* Sale: hide sale banners and stickers the moment the sale ends, even on a cached page */
(function () {
  var end = document.documentElement.getAttribute('data-sale-end');
  if (!end) return;
  var t = Date.parse(end);
  if (isNaN(t)) return;
  function check() { if (Date.now() > t) document.documentElement.classList.add('sale-over'); }
  check();
  setInterval(check, 60000);
})();

/* Sale countdown: during a sale, counts down to its end; on full-price days, counts down to the next sale */
(function () {
  var html = document.documentElement;
  var endStr = html.getAttribute('data-sale-end'), nextStr = html.getAttribute('data-next-start');
  var target = Date.parse(endStr || nextStr || '');
  if (isNaN(target)) return;
  var isNext = !endStr;
  var start = endStr ? Date.parse(html.getAttribute('data-sale-start') || '') : NaN;
  if (isNaN(start) || start >= target) start = target - 30 * 864e5;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var sel = isNext ? '[data-next-countdown]' : '[data-countdown]';
  function tick() {
    var left = Math.max(0, target - Date.now());
    var d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
    var pct = Math.max(0, Math.min(100, left / (target - start) * 100));
    document.querySelectorAll(sel).forEach(function (el) {
      var t = el.querySelector('[data-cd-time]');
      var compact = el.classList.contains('cdown--compact') || el.classList.contains('cdown--announce');
      if (t) t.innerHTML = '<b>' + d + '</b><i>d</i> <b>' + pad(h) + '</b><i>h</i> <b>' + pad(m) + '</b><i>m</i>' + (compact ? '' : ' <b>' + pad(s) + '</b><i>s</i>');
      var f = el.querySelector('[data-cd-fill]');
      if (f) f.style.width = pct.toFixed(2) + '%';
      var bar = el.querySelector('[role="progressbar"]');
      if (bar) bar.setAttribute('aria-valuenow', Math.round(pct));
      el.classList.toggle('is-ending', !isNext && left < 3 * 864e5);
    });
    if (left <= 0) {
      clearInterval(timer);
      if (isNext) {
        /* The next sale has just started: reload once so prices and banners switch over */
        try { if (sessionStorage.getItem('cw-sale-reload') !== nextStr) { sessionStorage.setItem('cw-sale-reload', nextStr); location.reload(); } } catch (e) {}
      } else {
        html.classList.add('sale-over');
      }
    }
  }
  var timer = setInterval(tick, 1000);
  tick();
})();

/* Back to top */
(function () {
  var b = document.createElement('button');
  b.type = 'button';
  b.className = 'to-top';
  b.setAttribute('aria-label', 'Back to top');
  b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  document.body.appendChild(b);
  b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  function on() { b.classList.toggle('is-on', window.scrollY > window.innerHeight * 1.2); }
  window.addEventListener('scroll', on, { passive: true });
  on();
})();
/* Accordions: opening one item closes its open siblings (FAQs, filters, menu groups, footer columns on mobile) */
(function () {
  var wideFooter = window.matchMedia('(min-width: 750px)');
  document.addEventListener('click', function (e) {
    var sum = e.target.closest('summary');
    if (!sum) return;
    var d = sum.parentElement;
    if (!d || d.tagName !== 'DETAILS' || d.open || !d.parentElement) return;
    if (d.hasAttribute('data-ft-col') && wideFooter.matches) return;
    if (d.hasAttribute('data-calc-toggle')) return;
    Array.prototype.forEach.call(d.parentElement.children, function (s) {
      if (s !== d && s.tagName === 'DETAILS' && s.open) s.open = false;
    });
  });
})();